import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Search, Link2 } from 'lucide-react';
import SubNav from './components/SubNav';
import ProjectSEO from './ProjectSEO';
import ProjectInternalLinks from './ProjectInternalLinks';

/**
 * Onglet fusionné « SEO & contenu » : tableau SEO des pages + maillage interne.
 */
export default function ProjectSeoTab({ defaultSub = 'seo' }) {
  const [params, setParams] = useSearchParams();
  const sub = params.get('sub') || defaultSub;
  const setSub = (key) => {
    const next = new URLSearchParams(params);
    next.set('sub', key);
    setParams(next, { replace: true });
  };

  return (
    <div className="flex flex-col gap-4">
      <SubNav
        active={sub}
        onChange={setSub}
        items={[
          { key: 'seo', label: 'URL & SEO', icon: Search },
          { key: 'links', label: 'Maillage interne', icon: Link2 },
        ]}
      />
      {sub === 'links' ? <ProjectInternalLinks /> : <ProjectSEO />}
    </div>
  );
}
